<template>
  <div class="admin-users">
    <v-card v-if="tab===1" class="align-self-stretch">
      <v-card-title class="card_ligth_header ma-0 pa-0">
        <v-row cols="6" class="pa-2 ma-2">
          <v-col cols="12">
            <h3>Курсы</h3>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="courseSearchValue"
              label="Что ищем"
              variant="outlined"
              clearable
              rounded
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <AppButton
              class="n-admin-cource__add"
              @click="courseDialog = true"
            >
              <span>Добавить</span>
            </AppButton>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-row>
          <v-col cols="12">
            <Vue3EasyDataTable
              class="mb-16 pb-16"
              :headers="courseHeaders"
              :items="courses"
              alternating
              show-index
              :search-field="courseSearchField"
              :search-value="courseSearchValue"
              :rows-per-page-message="'Записей на страницу'"
              :rows-per-page="15"
              :rows-items="[15,20,50]"
              :rows-of-page-separator-message="'из'"
              buttons-pagination
              :empty-message="'Данные не добавлены'"
            >
        <template #item-title="item">
          <div class="instant-tooltip-container">
            <!-- Название и лектор -->
            <div class="course-title">{{ item.title}}</div>
            <div class="course-author" v-if="item.coach">
              Лектор: {{ [item.coach.lastname, item.coach.firstname].filter(Boolean).join(' ') }}
            </div>
            <!-- Мгновенно всплывающее окно -->
            <div class="instant-tooltip-box" v-if="item.description">
              {{ item.description }}
            </div>
          </div>
        </template>

            <!-- Пример обновленного слота статус-баров и иконок -->
            <template #item-status="{ active, isPublic, stars }">
              <div class="d-flex flex-column gap-4">
                <!-- Бейджи статуса -->
                <div class="d-flex gap-4">
                  <span :class="['badge', active ? 'badge--success' : 'badge--secondary']" class="ma-1">
                    {{ active ? 'Активен' : 'Черновик' }}
                  </span>
                  <span v-if="isPublic" class="badge badge--info ma-1">Публичный</span>
                </div>
                <!-- Компактный рейтинг -->
                <div v-if="stars" class="table-rating ma-1">
                  <span class="star-icon">★</span> {{ stars }}
                </div>
              </div>
            </template>

            <!-- Компактные кнопки в один ряд -->
            <template #item-actions="item">
              <div class="d-flex gap-8 justify-content-end">
                <button class="btn-icon ma-1" title="События" @click="editCourseEvents(item)">📅</button>
                <button class="btn-icon ma-1" title="Изменить" @click="editCourse(item)">✏️</button>
                <button class="btn-icon btn-icon--danger ma-1" title="Удалить" @click="deleteCourse(item)">🗑️</button>
              </div>
            </template>

            </Vue3EasyDataTable>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <v-card v-if="tab===2" class="align-self-stretch">
      <v-card-title class="card_ligth_header">
        <h3 class="ma-2">События курса</h3>
      </v-card-title>
      <v-card-title class="card_ligth_header" style="min-height: 5vh">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="courseEventSearchBody"
              label="Найти"
              variant="outlined"
              clearable
              hint="Введите ключевое слово для поиска"
              rounded
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row>
              <div class="ml-4">
                <AppBackButton
                  class="n-admin-cource__back"
                  @click="tab=1"
                >
                  <span>К курсам</span>
                </AppBackButton>
              </div>
              <div class="ml-4">
                <AppButton
                  class="n-admin-cource__add"
                  @click="createCourseEvent"
                >
                  <span>Добавить</span>
                </AppButton>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <Vue3EasyDataTable
          class="mb-16 pb-16"
          :headers="courseEventHeaders"
          :items="courseEvents"
          :search-value="courseEventSearchBody"
          alternating
          show-index
          :rows-per-page-message="'Записей на страницу'"
          :rows-per-page="10"
          :rows-items="[10,20,50]"
          :rows-of-page-separator-message="'из'"
          buttons-pagination
          :empty-message="'Данные не добавлены'"
        >

          <template #item-eventStatus="{ eventDateTime, creator, eventTypeId  }">
            <p v-if="!!eventDateTime">Дата: <strong>{{ eventDateTime.replace('T', ' ')}}</strong> </p>
            <p v-if="!!eventTypeId">Тип:
              <strong v-if="eventTypeId===1" size="small">Вебинар</strong>
              <strong v-else size="small">Видео</strong>
            </p>
            <p v-if="!!creator">Добавил:
              <strong v-if="!!creator.lastname">{{creator.lastname   + " "}}</strong>
              <strong v-if="!!creator.firstname">{{creator.firstname   + " "}}</strong>
              <strong v-if="!!creator.secname">{{creator.secname}}</strong>
            </p>
          </template>

          <template #item-actions="item">
            <AppButton
              class="admin-lib__table_button d-flex flex__ai-c"
              @click="editEvent(item)"
            >
              <span>Изменить</span>
            </AppButton>
            <AppButton
              class="admin-lib__table_button d-flex flex__ai-c"
              @click="deleteEvent(item)"
            >
              <span>Удалить</span>
            </AppButton>
          </template>
        </Vue3EasyDataTable>
      </v-card-text>
    </v-card>
</div>
<div>


<v-dialog
  persistent
  transition="dialog-bottom-transition"
  fullscreen
  scrollable
  v-model="alertDialog"
>
  <v-card>
    <v-card-text>
      {{ alertDialogMessage }}
    </v-card-text>
    <v-card-actions class="card_ligth_actions">
      <v-btn color="primary" block @click="alertDialog = false">
        Закрыть
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog
  v-model="showRecord"
  persistent
  transition="dialog-bottom-transition"
  fullscreen
  scrollable
>
  <v-card>
    <v-card-text class="iframe-container">
      <iframe :src="this.recordUrl" allowfullscreen></iframe>
    </v-card-text>
    <v-card-actions class="card_ligth_actions">
      <v-btn color="primary" block @click="showRecord = false">
        Закрыть
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog
  v-model="courseDialog"
  persistent
  transition="dialog-bottom-transition"
  fullscreen
  scrollable
>
  <v-card>
    <v-card-title class="card_ligth_header">
      <h5>Курс</h5>
    </v-card-title>

    <v-card-text>
      <v-form
        ref="courseForm"
      >

        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Название*"
              v-model="title"
              :rules="titleRules"
              hint="Укажите название"
              :counter="250"
              variant="outlined"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="mb-16" style="height: 300px;">
              <v-label>Описание*</v-label>
                    <TextEditor
                            :value="description"
                            @update:value="onEventUpdate"
                          />
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="coach"
              :items="coachs"
              outlined
              dense
              chips
              small-chips
              closable-chips
              item-title="firstname"
              item-value="id"
              :rules="coachRules"
              label="Преподаватель"
            >
              <template v-slot:chip="{ props, item }">
                <v-chip
                  v-bind="props"
                  :text="item.raw.firstname +' '+item.raw.lastname"
                ></v-chip>
              </template>
              <template v-slot:item="{ props, item }">

                <v-list-item
                  v-bind="props"
                  :title="item.raw.firstname +' '+item.raw.lastname"
                  :subtitle="item.raw.username"
                ></v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="lessonsQuantity"
              :items="courseLessonCountItems"
              outlined
              dense
              chips
              small-chips
              variant="outlined"
              label="Занятий"
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-select
              v-model="stars"
              :items="starsItems"
              outlined
              dense
              chips
              small-chips
              variant="outlined"
              label="Рейтинг"
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-row
              class="px-4"
              fluid
            >
              <v-switch
                v-model="active"
                :label="'Опубликован'"
                color="success"
              >
              </v-switch>
              <v-chip class="ma-2" v-if="active"> Да</v-chip>
              <v-chip v-else class="ma-2"> Нет</v-chip>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row
              class="px-4"
              fluid
            >
              <v-switch
                v-model="isPublic"
                :label="'Публичный'"
                color="success"
              >
              </v-switch>
              <v-chip class="ma-2" v-if="isPublic"> Да</v-chip>
              <v-chip v-else class="ma-2"> Нет</v-chip>
            </v-row>
          </v-col>

        </v-row>

        <small>*обязательно для заполнения</small>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="card_ligth_actions">
      <v-spacer></v-spacer>
      <AppButton
        class="admin-lib__opener d-flex flex__ai-c"
        @click="closeForm"
      >
        <span>Отмена</span>
      </AppButton>
      <AppButton
        class="admin-lib__opener d-flex flex__ai-c"
        @click="saveCourse"
      >
        <span>Сохранить</span>
      </AppButton>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog
  v-model="courseEventDialog"
  persistent
  transition="dialog-bottom-transition"
  fullscreen
  scrollable
>
  <v-card>
    <v-card-text>
      <v-form
        ref="courseEventForm"
      >
        <v-row>
          <v-col cols="12">
            <h4>Событие курса</h4>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Название*"
              v-model="eventName"
              :rules="eventNameRules"
              hint="Укажите название"
              :counter="1500"
              variant="outlined"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="mb-16" style="height: 300px;">
            <v-label>Описание*</v-label>
            <TextEditor
              :value="eventDescription"
              @update:value="onEventDescriptionUpdate"
            />
          </v-col>
          <v-col cols="12" class="mt-6">
            <v-autocomplete
              v-model="eventTypeId"
              :items="eventTypes"
              outlined
              dense
              variant="outlined"
              label="Тип"
              item-title="name"
              item-value="id"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" v-if="eventTypeId===1">
            <v-autocomplete
              v-model="webinarId"
              :items="webinars"
              outlined
              dense
              item-title="webinarName"
              item-value="id"
              :rules="webinarRules"
              label="Вебинар"
              required
            >
              <template v-slot:item="{ props, item }">

                <v-list-item
                  v-bind="props"
                  :title="item.raw.webinarName"

                ></v-list-item>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" v-else>
            <v-autocomplete
              v-model="videoFileId"
              :items="videos"
              outlined
              dense
              item-value="id"
              item-title="videoDescription"
              :rules="videoFileRules"
              label="Видео"
              required

            >
              <template v-slot:item="{ props, item }">

                <v-list-item
                  v-bind="props"
                  :title="item.raw.videoDescription"
                ></v-list-item>
              </template>
            </v-autocomplete>
          </v-col>


          <v-col cols="12">
            <v-label>Дата проведения*</v-label>
            <datePicker
              v-model="eventDateTime"
              autoApply
              locale="ru"
            />
            <v-alert
              v-if="eventDateTimeAlert === true"
              border="top"
              color="red lighten-2"
              dark
            >
              Укажите дату проведения !
            </v-alert>
          </v-col>

        </v-row>

        <small>*обязательно для заполнения</small>
      </v-form>
    </v-card-text>

    <v-card-actions class="card_ligth_actions">
      <v-spacer></v-spacer>
      <AppButton
        class="admin-lib__opener d-flex flex__ai-c"
        @click="closeCourseEventForm"
      >
        <span>Отмена</span>
      </AppButton>
      <AppButton
        class="admin-lib__opener d-flex flex__ai-c"
        @click="saveCourseEvent"
      >
        <span>Сохранить</span>
      </AppButton>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog v-model="showLoader" persistent>
  <loader-ring></loader-ring>
</v-dialog>
<!-- Модальное окно подтверждения -->
<div v-if="isDeleteModalOpen" class="modal-overlay">
  <div class="modal-box">
    <h3>Подтверждение удаления</h3>
    <p>Вы действительно хотите удалить курс <strong>"{{ courseToDelete?.title }}"</strong>? <b>Это действие нельзя отменить!</b></p>
    <div class="modal-actions">
      <button class="btn-cancel" @click="isDeleteModalOpen = false">Отмена</button>
      <button class="btn-confirm" @click="confirmDeleteCourse">Удалить</button>
    </div>
  </div>
</div>
  </div>
</template>

<script>
import { customAxios} from "@/service/customAxios";
import {customStorage} from "@/service/customStorage";
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import AppButton from "@/elements/AppButton.vue";
import AppBackButton from "@/elements/AppBackButton.vue";
import LoaderRing from "@/elements/LoaderRing.vue";
  import TextEditor from "@/components/TextEditor.vue";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getIndex(list,id) {
  for (var i =0; i< list.length; i++) {
    if (list[i].id === id) {
      return i;
    }
  }
  return -1;
}

export default {
  name: 'AdminCoursePage',

  props: [],
  components:{
    LoaderRing,
    AppButton,
    Vue3EasyDataTable,
    AppBackButton,
    TextEditor
  },

  data: () => ({
    alertDialog:false,
    alertDialogMessage:'',
    showRecord:false,
    tab:1,
    courses:[],
    coachs:[],
    webinars:[],
    videos:[],
    courseDialog: false,

    id:'',
    title:'',
    active:false,
    isPublic:false,
    coach:null,
    coachId: null,
    description:'',
    img:  null,
    lessonsQuantity:0,
    stars: 0,

    courseSearchField:"title",
    courseSearchValue:'',

    starsItems:[0, 1, 2, 3 ,4 ,5],

    courseLessonCountItems:[0, 1, 2, 3 ,4 ,5, 6, 7, 8 , 9, 10],

    courseSearchOptions: [
      {value: "title", name: "Название"},
      {value: "description", name: "Описание"},
      {value: "createDateTime", name: "Создан"},
      {value: "active", name: "Активен"},
      {value: "lessonsQuantity", name: "Рейтинг"},
      {value: "stars", name: "Занятий"},

    ],

    courseHeaders: [
      { text: "id", value: "id", width: 10 },
      { text: "Название", value: "title" , sortable: true },
    //  { text: "Описание", value: "description" , sortable: true},
      { text: "Статус", value: "status" },
      { text: "Действие", value: "actions", width: 120 },
      ],

      courseEventHeaders: [
      { text: "id", value: "id", width: 10 },
      { text: "Название", value: "eventName"},
      { text: "Статус", value: "eventStatus"},
      { text: "Действие", value: "actions"},
    ],

    showLoader: false,
    descriptionRules: [
      v => !!v || 'Поле обязательно для заполнения!',
      v => (v && v.length <= 1000) || 'Значение до должно превышать 250 символов!',
    ],
    methodRules: [
      v => !!v || 'Поле обязательно для заполнения!',
    ],

    titleRules: [
      v => (v && v.length <= 150) || 'Значение до должно превышать 150 символов!',
    ],
    coachRules: [
      v => (!!v && true)  || 'Поле обязательно для заполнения!'
    ],
    webinarRules: [
      v => (v!==undefined)  || 'Поле обязательно для заполнения!'
    ],
    videoFileRules: [
      v => (v!==undefined)  || 'Поле обязательно для заполнения!'
    ],
    nameAlert:false,
    eventDateTimeAlert:false,
    isDeleteModalOpen: false,
    courseToDelete: null,
    courseEvents:[],
    selectedCourse:{},
    courseEventSearchBody:'',
    courseEventDialog:false,
    eventName:'',
    eventDescription:'',
    eventNameRules: [
      v => !!v || 'Поле обязательно для заполнения!',
      v => (v && v.length <= 1500) || 'Значение до должно превышать 1500 символов!',
    ],
    eventDescriptionRules: [
      v => !!v || 'Поле обязательно для заполнения!',
      v => (v && v.length <= 150000) || 'Значение до должно превышать 150000 символов!',
    ],
    eventTypeId: 1,
    videoFileId:'',
    webinarId:'',
    eventTypes: [
      { name: "Вебинар", id: 1 },
      { name: "Видео из библиотеки", id: 2},

    ],
    eventDateTime:'',

    videoFile:undefined,
    webinar:undefined,
  }),
    methods: {
           onEventUpdate(e) {
              console.log("Content Event description updated")
              this.description = e;
            },
        onEventDescriptionUpdate(e) {
          console.log("Content updated")
          this.eventDescription = e;
        },
    saveCourseEvent() {
        this.$refs.courseEventForm.validate().then((result) => {
          if (result.valid && this.eventDateTimeAlert === false) {
            console.log("webinarId:" + this.webinarId)
            console.log("videoFileId:" + this.videoFileId)

            if(this.eventTypeId instanceof Object){
              this.eventTypeId = this.eventTypeId.value
            }
            console.log("eventTypeId:" + this.eventTypeId)

            let event = {
              courseId: this.selectedCourse.id,
              eventName: capitalizeFirstLetter(this.eventName),
              eventDescription: capitalizeFirstLetter(this.eventDescription),
              eventTypeId: this.eventTypeId,
              eventDateTime: this.eventDateTime,
              videoFileId: this.videoFileId,
              webinarId: this.webinarId
            };

            if (this.id) {
              console.log("Редактируем webinar с Id : " + this.id);
              customAxios.put("course/event/" + this.id, event)
                  .then((response) => {
                    if (response.status === 202) {
                      let index = getIndex(this.courseEvents, response.data.id);
                      this.courseEvents.splice(index, 1, response.data);
                      this.id=''
                      this.eventName =''
                      this.eventDescription =''
                      this.eventTypeId=1
                      this.videoFileId=''
                      this.webinarId=''
                      this.eventDateTime=''
                      this.eventDateTimeAlert=false
                      this.courseEventDialog=false
                      this.id = "";
                    } else {
                      alert("что то пошло не так");
                      console.log(response);
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                  });
            } else {

              customAxios.post("course/event", event)
                  .then((response) => {
                    if (response.status === 201) {
                      console.log(response.data)
                      this.courseEvents.push(response.data);
                      this.eventName =''
                      this.eventDescription =''
                      this.eventTypeId=1
                      this.videoFileId=''
                      this.webinarId=''
                      this.eventDateTime=''
                      this.eventDateTimeAlert=false
                      this.courseEventDialog=false
                    } else {
                      alert("что то пошло не так");
                      console.log(response);
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                  });
            }
          }
        });

    },
    closeCourseEventForm(){
      this.eventName =''
      this.eventDescription =''
      this.eventTypeId=1
      this.videoFileId=''
      this.webinarId=''
      this.eventDateTime=''
      this.eventDateTimeAlert=false
      this.courseEventDialog=false
    },
    createCourseEvent(){
      this.id=''
      this.courseEventDialog=true;
    },
    editCourseEvents(item){
      this.selectedCourse = item;

      this.getVideos();
      this.getWebinars();

      customAxios
          .get("course/event/" + item.id)
          .then((response) => {
            if (response.status === 200) {
              this.courseEvents = response.data
              console.log(response.data)
              this.tab=2;
            } else {
              alert(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error)
          });

    },
    editEvent(item) {
      this.id = item.id;
      this.eventName = item.eventName;
      this.eventDescription = item.eventDescription;
      this.eventTypeId = item.eventTypeId;
      this.webinarId = item.webinarId;
      this.videoFileId = item.videoFileId;
      this.eventDateTime = item.eventDateTime;
      this.courseEventDialog = true;
    },
    deleteEvent(item) {

      customAxios.delete("course/event/" + item.id)
          .then((response) => {
            if (response.status === 202) {
              this.courseEvents.splice(getIndex(this.courseEvents, item.id), 1);
            } else {
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error)
          });
    },
    closeForm() {
      this.courseDialog = false
      this.id = ''
      this.title = ''
      this.description=''
      this.active = false
      this.isPublic = false
      this.coachId = null
      this.coach = null
      this.lessonsQuantity =0
      this.stars = 0
    },
    saveCourse() {
      this.$refs.courseForm.validate().then(responce =>{
        if(responce.valid){
          if(this.coach instanceof Object){
            this.coach = this.coach.id
          }
          let course = {
            title:capitalizeFirstLetter(this.title),
            description:capitalizeFirstLetter(this.description),
            coachId:this.coach,
            active: this.active,
            isPublic: this.isPublic,
            published:this.published,
            lessonsQuantity: this.lessonsQuantity,
            stars: this.stars,
            img: this.img
          }

          if (this.id) {
            customAxios.put('course/' + this.id, course)
                .then(response => {
                  if (response.status === 202) {
                    let index = getIndex(this.courses, response.data.id)
                    this.courses.splice(index, 1, response.data)
                    this.closeForm()
                  } else if (response.status === 207) {
                    alert(response.data.message)
                    console.log(response)
                  } else {
                    alert("что то пошло не так")
                    console.log(response)
                  }
                })
                .catch(error=> {
                  console.log(error)
                })
          }  else {
            customAxios.post('course', course)
                .then(response => {

                  if (response.status === 201) {
                    this.courses.push(response.data)
                    this.closeForm()
                  } else if (response.status === 207) {
                    alert(response.data.message)
                    console.log(response)
                  } else {
                    alert("что то пошло не так")
                    console.log(response)
                  }
                })
                .catch(error=> {
                  console.log("error:" + error.response.status)
                })
          }
        }
      })

    },
    editCourse(item) {
      console.log("cource:" + item)
      this.id = item.id
      this.title = item.title
      this.description=item.description
      this.active = item.active
      this.isPublic = item.isPublic
      this.coachId = item.coachId
      this.coach = item.coach
      this.lessonsQuantity =item.lessonsQuantity
      this.stars = item.stars
      this.courseDialog = true
    },
    deleteCourse: function (item) {
      this.courseToDelete = item;
      this.isDeleteModalOpen = true;
    },

    // Эту функцию вызываем при нажатии "Да, удалить" внутри модалки
    confirmDeleteCourse: function () {
      if (!this.courseToDelete) return;

      customAxios.delete('course/' + this.courseToDelete.id)
          .then(response => {
            if (response.status === 202) {
              this.courses.splice(getIndex(this.courses, this.courseToDelete.id), 1);
              this.isDeleteModalOpen = false; // Закрываем окно
              this.courseToDelete = null;     // Очищаем переменную
            } else {
              console.log(response);
            }
          })
          .catch(error => {
            console.log("error:" + error.response.status);
          });
    },
    getWebinars() {
      const r = customAxios.get('webinar')
      .then((response) => {
            if (response.status === 200) {
              this.webinars = response.data

            } else {
              alert(response.data.message);
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error)
          });
    },

    getVideos(){
      customAxios.get('library/video')
      .then((response) => {
            if (response.status === 200) {
              this.videos = response.data

            } else {
              alert(response.data.message);
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error)
          });
    }
  },
  computed: {

    usersList(){
      let newUsers = this.users
      return newUsers
    },
    jwtHeaders(){
      let jwtTokenConfig = {
        method: 'POST',
        headers: {
          Authorization: "Bearer " + customStorage.get("user-token"),
        },
        responseType: 'blob'
      }
      return jwtTokenConfig
    },

  },
  created: function () {
    this.showLoader=true
    function getCourses() {
      return customAxios.get('course/all')

    }
    function getCoachs() {
      return customAxios.get('person/coach')

    }
    Promise.all([
      getCourses(),
      getCoachs()
  ])
        .then(results => {
          if(results[0].status===200){
            this.courses = results[0].data;
          }
          if(results[1].status===200){
            this.coachs = results[1].data;
          }
          this.showLoader=false
        }).catch(error=> {
      this.showLoader=false
      alert("Ошибка: "+error+" загрузки данных, обратитесь к администратору системы!")

    });
  }
}
function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
</script>



<style lang="scss">

    /* Контейнер ячейки */
    .course-name-cell {
      cursor: help; /* Иконка знака вопроса у курсора намекает, что есть подсказка */
      padding: 4px 0;
    }

    /* Главное название курса */
    .course-title {
      font-weight: 600;
      font-size: 14px;
      color: #1a1a1a;
      line-height: 1.4;
      transition: color 0.2s ease;
    }

    /* Эффект при наведении, чтобы показать интерактивность */
    .course-name-cell:hover .course-title {
      color: #2b7de9; /* Делает название синеватым при наведении */
    }

    /* Подпись лектора под названием */
    .course-author {
      font-size: 12px;
      color: #8c8c8c;
      margin-top: 2px;
    }

/* Контейнер ячейки */
.tooltip-container {
  position: relative;
  cursor: pointer;
}

/* Стили превью-текста в таблице */
.table-course-description {
  font-size: 13px;
  color: #595959;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Скрытый по умолчанию блок с полной подсказкой */
.tooltip-text {
  position: absolute;
  z-index: 100;
  left: 0;
  bottom: 110%; /* Появляется чуть выше ячейки */
  width: 320px; /* Ограничиваем ширину всплывающего окна */
  background-color: #2c3e50;
  color: #fff;
  font-size: 12px;
  line-height: 1.4;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  /* Анимация исчезновения/появления */
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease;
  transform: translateY(4px);
  pointer-events: none; /* Чтобы окно не мешало курсору */
}

/* Треугольник-стрелочка внизу подсказки */
.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 20px;
  border-width: 6px;
  border-style: solid;
  border-color: #2c3e50 transparent transparent transparent;
}

/* Показываем подсказку при наведении на контейнер */
.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

/* Название курса */
.table-course-title {
  font-weight: 600;
  font-size: 15px;
  color: #1a1a1a;
  margin-bottom: 4px;
}

/* Имя лектора под названием */
.table-course-author {
  font-size: 12px;
  color: #8c8c8c;
}

.table-course-description {
  font-size: 13px;
  color: #595959;
  line-height: 1.4;

  /* Ограничение в 2 строки */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help; /* Меняет курсор, подсказывая, что есть подсказка */
}

    /* Ограничение текста описания, чтобы строки были одной высоты */
    .admin-lib__table-description {
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Показывать только 2 строки */
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: 13px;
      color: #666;
    }

    /* Компактные кнопки-иконки вместо огромных плашек */
    .btn-icon {
      background: none;
      border: 1px solid #e0e0e0;
      padding: 6px 10px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .btn-icon:hover {
      background-color: #f5f5f5;
    }
    .btn-icon--danger:hover {
      background-color: #ffebee;
      border-color: #ffc107;
    }

    /* Бейджи статусов */
    .badge {
      padding: 2px 6px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: bold;
    }
    .badge--success { background: #e8f5e9; color: #2e7d32; }
    .badge--info { background: #e3f2fd; color: #1565c0; }
    .badge--secondary { background: #f5f5f5; color: #757575; }




.n-admin-cource {
  &__input + .n-user-set-bio__input {
    margin-top: 16px;
  }

  &__add {
    @include button-default;
    margin-top: 0px;
  }

  &__back {
    @include button-default;
    margin-top: 0px;
  }
}


.customize-table {
  --easy-table-border: 1px solid #2a77bb;
  --easy-table-row-border: 1px solid #2a77bb;

  --easy-table-header-font-size: 14px;
  --easy-table-header-height: 50px;
  --easy-table-header-font-color: #E7EBF3;
  --easy-table-header-background-color: #1E88E5;

  --easy-table-header-item-padding: 10px 15px;

  --easy-table-body-even-row-font-color: #E7EBF3;
  --easy-table-body-even-row-background-color: rgba(28, 132, 224, 0.26);

  --easy-table-body-row-font-color: #E7EBF3;
  --easy-table-body-row-background-color: rgba(30, 136, 229, 0.49);
  --easy-table-body-row-height: 50px;
  --easy-table-body-row-font-size: 14px;

  --easy-table-body-row-hover-font-color: #1E88E5;
  --easy-table-body-row-hover-background-color: #eee;

  --easy-table-body-item-padding: 10px 15px;

  --easy-table-footer-background-color: #1E88E5;
  --easy-table-footer-font-color: #c0c7d2;
  --easy-table-footer-font-size: 14px;
  --easy-table-footer-padding: 0px 10px;
  --easy-table-footer-height: 50px;

  --easy-table-rows-per-page-selector-width: 70px;
  --easy-table-rows-per-page-selector-option-padding: 10px;
  --easy-table-rows-per-page-selector-z-index: 1;


  --easy-table-scrollbar-track-color: #2d3a4f;
  --easy-table-scrollbar-color: #2d3a4f;
  --easy-table-scrollbar-thumb-color: #4c5d7a;;
  --easy-table-scrollbar-corner-color: #2d3a4f;

  --easy-table-loading-mask-background-color: #2d3a4f;
}


.large-dialog.v-dialog .v-overlay__content {
  max-width: none;
  width: 100%;
}

.v-dialog--scrollable .v-overlay__content {
  justify-content: center;
}

.admin-users {
  @include page;

  &__item + .admin-clients__item {
    margin-top: 16px;
  }

  &__info {
    font-size: 18px;
    line-height: 30px;

    span {
      color: $accent-1;
    }

    svg {
      margin-right: 8px;
      stroke: $accent-1;
    }
  }

  &__name {
    display: flex;
    justify-content: space-between;
  }
}

/* Контейнер для названия (точка отсчета для тултипа) */
.instant-tooltip-container {
  position: relative;
  display: inline-block; /* Чтобы контейнер не растягивался на всю ширину ячейки */
  cursor: pointer;
  padding: 4px 0;
  width: 100%;
}

.course-title {
  font-weight: 600;
  font-size: 14px;
  color: #1a1a1a;
}

.course-author {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 2px;
}

/* Стили самого всплывающего окна (по умолчанию скрыто) */
.instant-tooltip-box {
  position: absolute;
  left: 0;
  bottom: 100%; /* Появляется строго НАД названием */
  transform: translateY(-8px);

  width: 350px; /* Фиксированная ширина, чтобы текст не тянулся в одну строку */
  background-color: #2c3e50; /* Красивый темный цвет */
  color: #ffffff;
  font-size: 13px;
  line-height: 1.4;
  padding: 10px 14px;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);

  /* Магия мгновенного скрытия/показа */
  display: none;
  z-index: 9999; /* Поверх любых элементов таблицы */
  pointer-events: none; /* Окно не мешает кликать по названию */
  white-space: normal; /* Разрешаем перенос строк внутри подсказки */
}

/* Стрелочка внизу окошка */
.instant-tooltip-box::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 20px;
  border-width: 6px;
  border-style: solid;
  border-color: #2c3e50 transparent transparent transparent;
}

/* МГНОВЕННЫЙ ПОКАЗ ПРИ НАВЕДЕНИИ */
.instant-tooltip-container:hover .instant-tooltip-box {
  display: block;
}

/* Небольшой интерактив: подсветим название */
.instant-tooltip-container:hover .course-title {
  color: #2b7de9;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный черный */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000; /* Выше таблицы и тултипов */
}

/* Белая карточка самого окна */
.modal-box {
  background: white;
  padding: 24px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-box h3 {
  margin-top: 0;
  color: #2c3e50;
}

.modal-box p {
  font-size: 14px;
  color: #595959;
  line-height: 1.5;
  margin: 16px 0 24px 0;
}

/* Блок кнопок внизу */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.modal-actions button {
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
}

/* Кнопка отмены */
.btn-cancel {
  background-color: #f5f5f5;
  color: #595959;
}
.btn-cancel:hover { background-color: #e0e0e0; }

/* Кнопка подтверждения (красная) */
.btn-confirm {
  background-color: #e53935;
  color: white;
}
.btn-confirm:hover { background-color: #d32f2f; }
</style>



